module.exports = __webpack_public_path__ + "static/media/login-hero.88e2e25a.svg";